module.exports = __webpack_public_path__ + "stylesheets/font-ko_eecd4b3c1b2211ca9fe4048d6a1bd9fd.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/fonts/font-ko.less
// module id = fbuv
// module chunks = 153 154